import { createFileRoute, redirect } from '@tanstack/react-router';

// Permitting moved to /permitting. Old links and bookmarks keep working.
export const Route = createFileRoute('/permitAdmin/')({
  beforeLoad: () => {
    throw redirect({ to: '/permitting', replace: true });
  },
});
